import { render, staticRenderFns } from "./global.vue?vue&type=template&id=420858e5&scoped=true&"
import script from "./global.vue?vue&type=script&lang=js&"
export * from "./global.vue?vue&type=script&lang=js&"
import style0 from "./global.vue?vue&type=style&index=0&id=420858e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420858e5",
  null
  
)

export default component.exports